module.exports = __webpack_public_path__ + "static/media/Maf_ViolenciaDeGeneroDigital_not.f7227482.jpg";